import { render } from "./econsSolutionScreen.vue?vue&type=template&id=f3a5a79a"
import script from "./econsSolutionScreen.vue?vue&type=script&lang=js"
export * from "./econsSolutionScreen.vue?vue&type=script&lang=js"

import "./econsSolutionScreen.vue?vue&type=style&index=0&id=f3a5a79a&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__